import { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Button,
  Card,
  Row,
  Col,
  Form,
  Input,
  Radio,
  Select,
} from "antd";
import moment from "moment";

import {
  openNotification,
  ContactField,
  AddressControl,
  localityEnum,
  contribEnum,
} from "@seims/shared";

import { GlobalOutlined } from "@ant-design/icons";
import util from "../../../utils/functions/custom";
import { Messages, Notify } from "../../../services/custom/Messages";
import lookupApi from "../../../services/partnershipLookupService";
import csApi from "../../../services/citizenscienceService";
import { recordError } from "../../../utils/logService";

export const OrganizationForm = ({
  formRef,
  formData,
  onShowCreate,
  onSaveOrganization,
}) => {
  const [types, setTypes] = useState([]);
  const [contributions, setContributions] = useState([]);
  const [localityOptions, setLocalityOption] = useState([]);
  const [defaultContact, setDefaultContact] = useState("+27");
  const [selectedOption, setSelectedOption] = useState("");
  const [address, setAddress] = useState();
  const [partnerSummary, setpartnerSummary] = useState({
    name: "",
    contact: "",
  });
  const [isLocal, setIsLocal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddressInfo, setshowAddressInfo] = useState(false);
  const [showOther, setShowOther] = useState(false);
  const [representatives, setRepresentatives] = useState([]);

  const dateFormat = "YYYY-MM";

  const formItemLayout = {
    labelCol: {
      span: 12,
    },
    wrapperCol: {
      span: 12,
    },
  };

  const horizontalLayout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
  };

  const { Option } = Select;
  const { Meta } = Card;
  const [form] = Form.useForm();
  const formName = "PartnerForm";
  const emailAddressRef = useRef(null);

  useEffect(() => {
    getPartnerTypes();
    getLocalityTypes();
    getContributions();
  }, []);

  const getPartnerTypes = async () => {
    try {
      const response = await lookupApi.getPartnerTypes();
      if (response) {
        const { data } = response;
        setTypes(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getLocalityTypes = async () => {
    try {
      const response = await lookupApi.getLocalityTypes();
      if (response) {
        const { data } = response;
        setLocalityOption(data.sort(util.setDynamicSort("key")));
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getContributions = async () => {
    try {
      const response = await lookupApi.getContributions();
      if (response) {
        const { data } = response;
        setContributions(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onChange = (selected) => {
    const selectedType = types.find((record) => record.value === selected);
    form.setFieldsValue({ partnerType: selectedType });
  };

  const onInitiationChange = (selectedDate) => {};

  const disabledDates = (current) => {
    return current && current > moment().endOf("day");
  };

  const onChangeLocality = (e) => {
    const { value: selected } = e.target;
    const selectedLocality = localityOptions.find(
      (record) => record.key === selected
    );

    if (selectedLocality.value == localityEnum.LOCAL) {
      setIsLocal(true);
    } else {
      setIsLocal(false);
    }

    setSelectedOption(selected);
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleContactChange = (value) => {
    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ contact: undefined });
      form.setFieldsValue({ contact: util.toNumeric(value) });
      return;
    }
    form.setFieldsValue({ contact: value });
    let partner = { ...partnerSummary };
    partner.contact = value;
    setpartnerSummary(partner);
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
    let partner = { ...partnerSummary };
    partner.name = textValue;
    setpartnerSummary(partner);
  };

  const handleModalSubmit = (values) => {
    let _address = { ...values, country: values.country.value };

    if (isLocal) {
      _address = {
        ...values,
        country: values.country.value,
        province: values.province.value,
      };
    }
    setAddress(_address);
    setShowModal(false);
    setshowAddressInfo(true);
    form.setFields([
      {
        name: "address",
        value: _address,
        errors: [],
      },
    ]);
  };

  const handleSubmit = () => {
    try {
      addOrganization();
    } catch (error) {
      console.log(">>> ERROR", error);
      openNotification("Error", "An unusual error has happened", Notify.ERROR);
      recordError(error);
      console.error(
        `THERE ARE ${error?.errorFields?.length} REQUIRED FIELDS WITHOUT VALUES`
      );
    }
  };

  const addOrganization = async () => {
    var msg;
    var action = "Adding Partner";
    var partnerReq = form.getFieldsValue();

    try {
      const request = await csApi.addPartnership(partnerReq, address);

      if (request?.status == 200 || request?.status == 201) {
        const { id } = request?.data;
        const { key, value } = partnerReq?.partnerType;
        const filteredContr = contributions?.filter((c) =>
          partnerReq?.contributions.includes(c.key.toString())
        );
        let modifiedContributions;
        // console.log("OTHER", partnerReq, key, value);
        //Remove unused object attributes
        delete partnerReq["contributions"];
        delete partnerReq["partnerType"];

        if (filteredContr.length > 0) {
          modifiedContributions = filteredContr.map((c) => ({
            label: c.value.toString(),
            value: c.key.toString(),
          }));
        }

        const organizationDetails = {
          ...partnerReq,
          id: id,
          contributions: modifiedContributions,
          type: value,
          typeid: key,
          // otherContributionss: partnerReq.otherContribution,
        };

        onSaveOrganization(organizationDetails);
        // setCreateData(formData);
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Partner");
        openNotification(action, msg, Notify.SUCCESS);
        onShowCreate(false);
        clearFormContents();
        return true;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Partner");
      openNotification(action, msg, Notify.ERROR);
      return false;
    } catch (error) {
      if (error?.response?.status == 409) {
        msg = util.parseMessage(Messages.EXIST_ADD_FAILURE, "Partner");
        openNotification(action, msg, Notify.ERROR);
        recordError(error);

        return false;
      }
    }
  };

  const clearFormContents = () => {
    form.resetFields();
    setSelectedOption("");
    setAddress({});
    setpartnerSummary({});
    setShowModal(false);
    setshowAddressInfo(false);
    setShowOther(false);
  };

  const onContributeSelection = () => {
    const otherContribution = contributions.find(
      (record) => record.value === contribEnum.OTHER
    );

    const selectedValues = form.getFieldValue("contributions");

    // if (selectedValues.includes(otherContribution.key.toString())) {
    //   setShowOther(true);
    // } else {
    //   setShowOther(false);
    // }
  };

  const onCancel = () => {
    onShowCreate(false);
  };

  const checkEmailExistance = async () => {
    const entity = "Email";
    var msg;
    var inputCheck = form.getFieldValue("email");
    try {
      if (inputCheck) {
        const emailValidity = await csApi.checkEmailExists(inputCheck);
        if (emailValidity.status == 204) {
          return;
        }
      }
    } catch (error) {
      if (error.response.status == 409) {
        msg = util.parseMessage(Messages.USER_EXISTS, entity);

        openNotification("Email validation", msg, Notify.WARNING);
        emailAddressRef.current.focus();
        recordError(error);
        return;
      } else {
        msg = util.parseMessage(Messages.INVALID_EMAIL_DOMAIN, entity);
        openNotification("Email validation", msg, Notify.ERROR);

        emailAddressRef.current.focus();
        recordError(error);
        return;
      }
    }
  };

  return (
    <>
      <div>
        <div>
          <Form
            {...formItemLayout}
            name={formName}
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            ref={formRef}
            initialValues={formData}
          >
            <Row>
              <Col xs={24} sm={8} md={12}>
                <Form.Item
                  name="name"
                  label="Partner Name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter partner name",
                    },
                  ]}
                >
                  <Input name="name" onBlur={onNameBlur} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={12}>
                <Form.Item name="Acronym" label="Partner Name (Acronym)">
                  <Input name="Acronym" onBlur={onNameBlur} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={12}>
                <Form.Item
                  name="contact"
                  label="Contact"
                  rules={[
                    {
                      required: true,
                      message: "Please enter partner contact",
                    },
                    {
                      min: 10,
                      message: "Contact length expects 10 numeric values",
                    },
                  ]}
                >
                  <ContactField
                    onContactChange={handleContactChange}
                    contactValue={defaultContact}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={12}>
                <Form.Item
                  name="email"
                  label="Partner Email"
                  onBlur={checkEmailExistance}
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please enter partner Email",
                    },
                  ]}
                >
                  <Input ref={emailAddressRef} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={8} md={12}>
                <Form.Item
                  name="contributions"
                  label="Contributions"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least 1 contribution type",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Please select"
                    onSelect={onContributeSelection}
                    onChange={onContributeSelection}
                  >
                    {contributions.map((contribute) => (
                      <Option key={contribute.key}>{contribute.value}</Option>
                    ))}
                  </Select>
                </Form.Item>

                {showOther && (
                  <Form.Item
                    name="otherContribution"
                    label="Other"
                    rules={[
                      {
                        required: true,
                        message: "Please enter other contibutions",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={8} md={12}>
                <Form.Item
                  name="partnerType"
                  label="Partner Type"
                  rules={[
                    {
                      required: true,
                      message: "Please select partner type",
                    },
                  ]}
                >
                  <Select onChange={onChange}>
                    {types.map((type) => (
                      <Option key={type.value}>{type.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col xs={24} sm={8} md={12}>
              <Form
                layout="horizontal"
                form={form}
                name={formName}
                ref={formRef}
              >
                <Form.Item
                  name="address"
                  label="Address Options"
                  rules={[
                    {
                      required: true,
                      message: "Please select partner address option",
                    },
                  ]}
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 12 }}
                >
                  <Radio.Group
                    onChange={onChangeLocality}
                    value={selectedOption}
                  >
                    {localityOptions.map((option) => (
                      <Radio key={option.key} value={option.key}>
                        {option.value}
                      </Radio>
                    ))}
                  </Radio.Group>
                  <div>
                    {showAddressInfo && (
                      <Card
                        style={{
                          width: "100%",
                          marginTop: 16,
                          justifyContent: "center",
                          marginBottom: 10,
                          backgroundColor: "rgb(250 250 250)",
                          borderBlockStyle: "solid",
                          borderColor: "#CCC",
                        }}
                        actions={[
                          <Button
                            key="Edit"
                            value="Edit"
                            type="default"
                            onClick={() => setShowModal(true)}
                          >
                            Edit
                          </Button>,
                        ]}
                      >
                        {isLocal ? (
                          <Meta
                            avatar={<Avatar icon={<GlobalOutlined />} />}
                            title={"Local Address"}
                            description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}, ${address.country}`}
                          />
                        ) : (
                          <Meta
                            avatar={<Avatar icon={<GlobalOutlined />} />}
                            title={"Foreign Address"}
                            description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}, ${address.country}`}
                          />
                        )}
                      </Card>
                    )}
                  </div>
                </Form.Item>
                {/* <Form.Item
                  name="scishop"
                  label="Is the facility at this institution a Science Shop?"
                  rules={[
                    {
                      required: true,
                      message: "Is it a science shop",
                    },
                  ]}
                  // labelCol={{span: 12}}
                  wrapperCol={{ span: 6 }}
                >
                  <Radio.Group
                    onChange={onChangeScienceOption}
                    value={selectedScienceShop}
                  >
                    {booleanOptions.map((option) => (
                      <Radio key={option.key} value={option.key}>
                        {option.value}
                      </Radio>
                    ))}
                  </Radio.Group>
                </Form.Item> */}
              </Form>
              {/* </div> */}
            </Col>
          </Row>
          <div style={{ padding: "20px", textAlign: "right" }}>
            <Row gutter={[16, 16]} justify="end">
              <Col xs={24} sm={8} md={6} lg={4}>
                <Button
                  key="2"
                  onClick={onCancel}
                  form={formName}
                  type="default"
                  block
                >
                  Cancel
                </Button>
              </Col>
              <Col xs={24} sm={8} md={6} lg={4}>
                <Button
                  key="2"
                  htmlType="submit"
                  onClick={handleSubmit}
                  form={formName}
                  type="primary"
                  block
                >
                  Save
                </Button>
              </Col>
            </Row>
          </div>
        </div>
        <AddressControl
          key="2"
          onCancel={handleCancel}
          visible={showModal}
          title="Add Address"
          isLocal={isLocal}
          onModalSubmit={handleModalSubmit}
          address={address}
        />
      </div>
    </>
  );
};
